export default __webpack_public_path__ + "static/media/whatsapp-blue.db172ae1.svg";